/*
 * Where the directory's two sections live in the URL.
 *
 * The people directory is one route, `/people`, and its section is a search parameter: `?tab=groups`
 * is the groups list and `?tab=groups&group=<handle>` is one group. Both are ordinary links, so a
 * section is bookmarkable and the back button walks it — and the parser never throws: an unreadable
 * parameter falls back to the person list, because a bad link should still open the page
 * (spec 12 §4.1).
 */

/** Which section of the directory a location names. */
export interface DirectoryLocation {
	tab: "people" | "groups"
	/** The handle of the group whose page is open, when one is. */
	group?: string
}

/** The section a `location.search` object names. */
export function parseDirectory(search: Record<string, unknown>): DirectoryLocation {
	if (search["tab"] !== "groups") return { tab: "people" }
	const group = search["group"]
	return typeof group === "string" && group !== "" ? { tab: "groups", group } : { tab: "groups" }
}

/** The search parameters of the person list. */
export const peopleSearch: Record<string, string> = {}

/** The search parameters of the groups list. */
export const groupsSearch: Record<string, string> = { tab: "groups" }

/** The search parameters of one group's page. */
export function groupSearch(handle: string): Record<string, string> {
	return { tab: "groups", group: handle }
}

/** The address of the direct conversation with one person (spec 05 §2.3). */
export function directMessagePath(handle: string): string {
	return `/d/${encodeURIComponent(handle)}`
}
